import React, { useState } from 'react';
import '../../../shared/StyledInput.css';
import RequiredMark from '../../../shared/RequiredMark';
import CancelButton from '../../../shared/CancelButton';
import SaveButton from '../../../shared/SaveButton';

function BrandTypeForm({ initial, onSave, onCancel, loading }) {
  const [name, setName] = useState(initial?.name || '');
  const [error, setError] = useState('');

  const validate = () => {
    if (!name.trim()) return 'Name is required.';
    return '';
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const err = validate();
    if (err) return setError(err);
    setError('');
    onSave({ name: name.trim() });
  };

  return (
    <form className="brand-type-form" onSubmit={handleSubmit} style={{ minWidth: 320 }}>
      <div>
        <label>Name<RequiredMark /></label><br />
        <input
          className="styled-input"
          value={name}
          onChange={(e) => setName(e.target.value)}
          maxLength={100}
          placeholder="e.g., Competitor"
          style={{ width: 260 }}
        />
      </div>

      {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}

      <div style={{ marginTop: 12 }}>
        <SaveButton loading={loading} />
        <CancelButton onClick={onCancel} disabled={loading} style={{ marginLeft: 8 }} />
      </div>
    </form>
  );
}

export default BrandTypeForm;
